import { PreferencesBulkUpsertLandingComponent } from './preferences-bulk-upsert-landing.component';

export const containers: any[] = [PreferencesBulkUpsertLandingComponent];

export * from './preferences-bulk-upsert-landing.component';